import { Outlet } from "react-router-dom"
import LocomotiveProvider from "../LocomotiveProvider"
import NavBar from "./Nav/NavBar"
import "../Scroll.css"

const Layout = () => {
  return (
    <>
      <NavBar />
      <LocomotiveProvider>
        <main>
          <Outlet />
        </main>
      </LocomotiveProvider>
    </>
  )
}

export default Layout
